import React, { useEffect, useState } from "react";
import Dropdown from "../DropDown";
import apiClient from "../../../services/apiClient";
import { getHeaders } from "../../ApiHeaders/apiHeaders";
import { datadogLogs } from "@datadog/browser-logs";

interface RevenueGroupDropdownProps {
  selectedValue: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  className?: string;
  isAssetRevenueTab?: boolean;  
}

const RevenueGroupDropdown: React.FC<RevenueGroupDropdownProps> = ({
  selectedValue,
  isAssetRevenueTab,
  onChange,
  disabled = false,
  className = "w-full p-1 sm:p-1 pl-4 pr-16 border border-gray-300 rounded-lg bg-[#f6f6f6] text-[#000000] shadow-inner text-xs md:text-base appearance-none",
}) => {
  const [options, setOptions] = useState<{ label: string; value: string }[]>(
    []
  );
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchRevenueGroups = async () => {
      try {
        const cachedData = sessionStorage.getItem("revenueGroups");
        if (cachedData) {
          setOptions(JSON.parse(cachedData));
          return;
        }

        const headers = await getHeaders();
        const response = await apiClient.get("/ref-data/dimensions", {
          headers,
        });

        if (response.data?.response?.data) {
          const apiData = response.data.response.data;

          const formattedData = Object.entries(apiData).map(
            ([label, value]) => ({
              label,
              value: String(value),
            })
          );

          setOptions(formattedData);
          sessionStorage.setItem(
            "revenueGroups",
            JSON.stringify(formattedData)
          );
          datadogLogs.logger.info("Fetched revenue groups successfully", {
            apiData,
          });
        }
      } catch (error) {
        datadogLogs.logger.error("Error fetching Revenue Groups", { error });
      } finally {
        setLoading(false);
      }
    };

    fetchRevenueGroups();
  }, []);
//   useEffect(() => {
//   if (!loading && options.length > 0 && isAssetRevenueTab) {
//     const match = options.find(
//       (opt) => opt.label.toLowerCase().includes("charge code")
//     );

//     if (match && (selectedValue === "total" || !selectedValue)) {
//       onChange(match.value);
//     }
//   }
// }, [loading, options, isAssetRevenueTab]);
const filteredOptions =
  isAssetRevenueTab
    ? options.filter(
        (opt) =>
          opt.label.toLowerCase() !==
          "resource"
      )
    : options;

  return (
    <Dropdown
    // options={options}
      options={filteredOptions}
      selectedValue={selectedValue}
      onValueChange={onChange}
      disabled={disabled || loading}
      className={className}
      placeholder="Select a Revenue Group"
    />
  );
};

export default RevenueGroupDropdown;
